import { Input, Component, OnInit } from "@angular/core";
import { NavController, Platform } from "ionic-angular";
import { IdolprofilePage } from "../../pages/idolprofile/idolprofile";
import { FannelPage } from "../../pages/fannel/fannel";

@Component({
  selector: "profile",
  templateUrl: "profile.html",
})
export class ProfileComponent implements OnInit {
  @Input()
  public idol: any;
  ios: boolean;
  public idolprofilePage = IdolprofilePage;

  constructor(public navCtrl: NavController, public platform: Platform) {
    if (this.platform.is("ios")) {
      this.ios = true;
    } else {
      this.ios = false;
    }
    this.ios = false;
  }

  ngOnInit() {
    console.log("idol ", this.idol);
  }

  openProfilePage() {
    this.navCtrl.push(IdolprofilePage, { idol: this.idol });
  }

  openFannel() {
    this.navCtrl.push(FannelPage, { idol: this.idol });
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/profile.ts